import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone, MapPin } from "lucide-react";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets`;

const links = [
  { to: "/", label: "Home" },
  { to: "/our-story", label: "Our Story" },
  { to: "/products", label: "Products" },
  { to: "/flavours", label: "Flavours" },
  { to: "/parlours", label: "Parlours" },
  { to: "/speciality", label: "Speciality" },
  { to: "/contact", label: "Contact" },
  { to: "/grow-with-us", label: "Grow With Us" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-cream/85 border-b border-[#F0E4E4]" data-testid="top-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="logo-link">
            <img src={`${ASSET_BASE}/logo.png`} alt="Holiday Ice Creams" className="h-12 md:h-14 w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
            {links.map(l => (
              <NavLink
                key={l.to} to={l.to}
                data-testid={`desktop-nav-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full font-medium text-sm tracking-wide transition-colors ${
                    isActive ? "bg-choc text-cream" : "text-choc hover:bg-ice-pink"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/bulk-order"
              className="hidden md:inline-flex items-center gap-2 bg-holiday-red text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-holiday-red-deep transition-all hover:scale-105"
              data-testid="topnav-bulk-order-btn"
            >
              Bulk Order →
            </Link>
            <a href="tel:9235372759" className="hidden md:inline-flex items-center gap-2 px-3 py-2 rounded-full hover:bg-mint" data-testid="topnav-phone-btn">
              <Phone className="w-4 h-4" /> <span className="text-sm font-semibold">9235372759</span>
            </a>
            <button
              onClick={() => setOpen(!open)}
              className="lg:hidden p-2 rounded-full hover:bg-ice-pink"
              data-testid="mobile-menu-toggle"
              aria-label="Open menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-4 grid grid-cols-2 gap-2" data-testid="mobile-nav-drawer">
            {links.map(l => (
              <NavLink
                key={l.to} to={l.to} onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-2xl font-semibold text-sm ${
                    isActive ? "bg-choc text-cream" : "bg-ice-pink text-choc"
                  }`}
              >{l.label}</NavLink>
            ))}
            <Link to="/bulk-order" onClick={() => setOpen(false)} className="col-span-2 bg-holiday-red text-white px-4 py-3 rounded-2xl font-bold text-center" data-testid="mobile-nav-bulk-order">
              Bulk Order →
            </Link>
            <a href="https://maps.app.goo.gl/xd1he1c7UpNeaTuV9" target="_blank" rel="noreferrer" className="col-span-2 flex items-center justify-center gap-2 bg-mint text-choc px-4 py-3 rounded-2xl font-semibold">
              <MapPin className="w-4 h-4" /> Find us on Google Maps
            </a>
          </div>
        )}
      </div>
    </header>
  );
}

